import { NodeSelection } from '@tiptap/pm/state';
import { Editor } from '@tiptap/react';

interface UseBlockToolInputFocusArgs {
  editor: Editor;
  getPos: () => number | undefined;
}

export const useBlockToolInputFocus = ({ editor, getPos }: UseBlockToolInputFocusArgs) => {
  const onBlockInputFocus = () => {
    const pos = getPos();

    if (pos !== undefined && editor.view) {
      const { state, dispatch } = editor.view;

      dispatch(state.tr.setSelection(NodeSelection.create(state.doc, pos)));
    }
  };

  return { onBlockInputFocus };
};
